/*
	PromiseQueue
	============

	A service to queue up promises. It's possible to add a delay
	so if you need to show a loading indicator, it won't flash
	if the promise is resolved quickly. By default, the delay
	is 200 ms.


	Usage
	-----

	$scope.myQueue = new PromiseQueue([delay]);
	myQueue.enqueue(myPromise);

	$scope.$watch('myQueue.length', function(length) {
		if (length > 0) {
			// promises are pending
		}
		else {
			// promises have resolved
		}
	});

 */

angular.module('jv.Common.PromiseQueue', [])

.factory('PromiseQueue', ['$timeout', '$injector', function($timeout, $injector) {

	var PromiseQueue = function(delay) {
		this.queue = [];
		this.delay = delay || 200;
		this.length = 0;
	};

	PromiseQueue.prototype.enqueue = function(promise) {
		var item, dequeueItem, then;

		then = (promise.$then || promise.then);

		if (!then) {
			throw new Error('PromiseQueue.enqueue expects a promise');
		}

		item = {
			timer: $timeout(angular.bind(this, function() {
				this.length++;
			}), this.delay),
			promise: promise
		};
		dequeueItem = angular.bind(this, dequeue, item);

		this.queue.push(item);
		promise.$then ? promise.$then(dequeueItem, dequeueItem) : promise.then(dequeueItem, dequeueItem);
	};

	function dequeue (item) {
		angular.forEach(this.queue, function(iItem, i) {
			if (item == iItem) {
				this.queue.splice(i, 1);
			}
		}, this);
		if (!$timeout.cancel(item.timer)) {
			$timeout(angular.bind(this, function() {
				this.length--;
			}), this.delay);
		}
	}

	return function (delay) {
		return $injector.instantiate(PromiseQueue, { delay: delay });
	}
}]);